import { useSearchParams } from 'react-router-dom';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle2 } from 'lucide-react';
import { useShareableLinkBranding } from '../hooks/useSource';
import { usePageBranding } from '../hooks/usePageBranding';
import pliableLogo from '../assets/images/pliable/logo_with_text_black.png';

export default function AuthCompletePage() {
  const [searchParams] = useSearchParams();
  const sourceType = searchParams.get('sourceType') || 'your';
  const linkCode = searchParams.get('linkCode') || undefined;

  const { data: brandingData } = useShareableLinkBranding(linkCode);
  const branding = brandingData?.branding;
  const logoPath = branding?.logo_path || pliableLogo;
  const brandName = branding?.page_title || 'Pliable';

  usePageBranding(branding);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-8">
          <img src={logoPath} alt={brandName} className="h-8" />
        </div>
        <Card>
          <CardContent className="pt-6 text-center space-y-4">
            <CheckCircle2 className="mx-auto h-12 w-12 text-green-500" />
            <h1 className="text-2xl font-semibold">Authorization Complete</h1>
            <p className="text-muted-foreground">
              Your {sourceType} account has been successfully connected. You're all set!
            </p>
            <p className="text-sm text-muted-foreground">
              If you have any questions, please contact{' '}
              <a href="mailto:support@pliable.co" className="underline">
                support@pliable.co
              </a>
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
